import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { ItemNameId } from '@/components/elements/ManyItemsTooltip/CategorizedHint';
import { API_URL } from '@/dtos';

interface IntersectionPayload {
  intersection_organization_ids?: number[];
  intersection_service_ids?: number[];
  is_generic?: boolean;
  team_id?: number;
  team_name?: string;
}

export interface Intersection {
  intersectionOrganizations?: ItemNameId[];
  intersectionServices?: ItemNameId[];
  isGeneric?: boolean;
  teamId?: string;
  teamName?: string;
}

const formatPayload = (data: IntersectionPayload[]) =>
  data.map(
    (item) =>
      ({
        intersectionOrganizations: item?.intersection_organization_ids?.map((id) => ({ id: toString(id) })),
        intersectionServices: item?.intersection_service_ids?.map((id) => ({ id: toString(id) })),
        isGeneric: item?.is_generic,
        teamId: toString(item?.team_id),
        teamName: item?.team_name,
      }) as Intersection
  );

interface Props {
  name?: string;
  servicesIds?: number[];
  organizationsIds?: number[];
  isGenericClaimsTeam?: boolean;
  isDefault?: boolean;
}

const useGetAlreadyExistClaimsTeamsQuery = () => {
  const { mutateAsync, isLoading } = useMutation((value: Props) =>
    // TODO: IClaimsTeamInfoDto type is not suitable there
    api.post(API_URL.CLAIMS_TEAMS_SEARCH_ASSIGNED, {
      name: value?.name,
      allowed_services: value?.servicesIds,
      assigned_organizations_ids: value?.organizationsIds,
      is_default: value?.isDefault,
      is_generic_claims_team: value?.isGenericClaimsTeam,
    })
  );

  const getAlreadyExistsTeams = useCallback(
    async (props: Props) => {
      const { data } = await mutateAsync(props);

      return formatPayload(data || []);
    },
    [mutateAsync]
  );

  return {
    isLoading,
    getAlreadyExistsTeams,
  };
};

export default useGetAlreadyExistClaimsTeamsQuery;
